// Admin API — Wallet manual adjust + user forensic + package stats.
//
// Backed by `backend/routes/admin_wallet.py`. All endpoints require
// `is_admin=true` via the shared axios instance in `./client`.
import api from './client';

/** Return the list of allowed reason codes (kept in sync with backend). */
export const ADJUST_REASONS = [
  { value: 'refund',          label: 'Rimborso' },
  { value: 'compensation',    label: 'Compensazione' },
  { value: 'customer_support', label: 'Assistenza Cliente' },
  { value: 'correction',      label: 'Correzione errore' },
  { value: 'promo_bonus',     label: 'Bonus promozionale' },
  { value: 'contest',         label: 'Contest' },
  { value: 'test',            label: 'Test' },
  { value: 'other',           label: 'Altro' },
];

/** Manually adjust a user's wallet.
 *  operation ∈ {"add","remove","set"}
 *  reason ∈ ADJUST_REASONS[].value
 */
export const adminAdjustUserWallet = async (userId, { operation, amount, reason, note }) => {
  const r = await api.post(`/admin/users/${userId}/wallet/adjust`, {
    operation, amount: Number(amount), reason, note: note || null,
  });
  return r.data;
};

/** Look up a user by email / username / user_number. Returns the same
 *  minimal profile shape as the forensic endpoint's `user` field. */
export const adminLookupUser = async (params) => {
  const qs = new URLSearchParams();
  if (params.email) qs.set('email', params.email);
  if (params.username) qs.set('username', params.username);
  if (params.user_number != null) qs.set('user_number', String(params.user_number));
  const r = await api.get(`/admin/users/lookup?${qs.toString()}`);
  return r.data;
};

/** Full wallet forensic dump for a user (audit_log + purchases +
 *  sessions + payouts + adjustments + reconciliation). */
export const adminWalletForensic = async (userId) => {
  const r = await api.get(`/admin/users/${userId}/wallet/forensic`);
  return r.data;
};

/** Per-package purchase KPIs (count, credits sold, revenue EUR). */
export const adminWalletPackagesStats = async () => {
  const r = await api.get('/admin/wallet/packages/stats');
  return r.data;
};
